import CreateFragmentModalContainer from './CreateFragmentModalContainer'
import CreateFragmetModal from './CreateFragmetModal'
export { CreateFragmetModal }
export { CreateFragmentModalContainer }
export default CreateFragmentModalContainer



// WEBPACK FOOTER //
// ./src/components/CreateFragmetModal/index.js